import request from '@/utils/request'

/**
 * 管理员获取消息组列表
 * @param {*} params { page_num, page_size, name, type, status}
 */
export function fetchManagerGroup(params) {
  return request({
    url: '/event/group',
    method: 'get',
    params
  })
}

/**
 * @param {id, params} id: 消息组id params {page_num, page_size, level, system, module, department, message, start_time, end_time} 搜索条件
 */
export function fetchManagerMessage({ id, params }) {
  return request({
    url: `/event/group/${id}/message`,
    method: 'get',
    params
  })
}

/** 更新消息组成员 */
export function updateGroupMember(id, data) {
  return request({
    url: `/event/group/${id}/member`,
    method: 'put',
    data
  })
}

/**
 * 用户获取消息组列表
 * @param {*} params { page_num, page_size, name, type, status}
 */
export function fetchUserGroup(params) {
  return request({
    url: '/user/group',
    method: 'get',
    params
  })
}

/**
 * @param {id, params} id: 消息组id params {page_num, page_size, level, system, module, department, message, start_time, end_time} 搜索条件
 */
export function fetchUserMessage({ id, params }) {
  return request({
    url: `/user/group/${id}/message`,
    method: 'get',
    params
  })
}
